import instObj from '@/backend/axios-instances'

const resource = "/estimations/parameters"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  },
  put(data, parameters) {
    return instance.put(resource, data, { params: parameters });
  }
}